export const METHODOLOGIES = [
    {
        id: 1,
        title: 'Reunión con asesor patrimonial',
        description: `Primera conversación para conocerte, entender tu situación financiera actual y los objetivos que guían tu planificación patrimonial.`,
        image: 'assets/svg/methodologies-1.svg',
    },
    {
        id: 2,
        title: 'Definición de objetivos patrimoniales',
        description: `Definimos juntos metas claras y medibles para orientar la estrategia de construcción, protección y gestión de tu capital.`,
        image: 'assets/svg/definition.svg'
    },
    {
        id: 3,
        title: 'Diagnóstico financiero integral',
        description: `Analizamos tu perfil, necesidades y riesgos, identificando oportunidades de optimización y planificación.`,
        image: 'assets/svg/verify-data.svg'
    },
    {
        id: 4,
        title: 'Recomendación de soluciones',
        description: `Te entregamos propuestas personalizadas, respaldadas por instituciones de prestigio internacional y adaptadas a tus metas.`,
        image: 'assets/svg/work-in-progress.svg'
    },
    {
        id: 5,
        title: 'Armado y presentación de tu File de cliente',
        description: `Reunimos y organizamos la documentación necesaria para solicitar la apertura de la cuenta, póliza o fondo a tu nombre, cumpliendo de manera rigurosa las políticas de compliance.`,
        image: 'assets/svg/legal-counsel.svg'
    },
    {
        id: 6,
        title: 'Fondeo y activación de soluciones',
        description: `Transfieres directamente los fondos a tu propia cuenta de inversión, póliza o producto a tu nombre, asegurando transparencia total y custodia internacional.`,
        image: 'assets/svg/stripe-payments.svg'
    },
    {
        id: 7,
        title: 'Monitoreo de portafolio y estrategia',
        description: `Realizamos un seguimiento continuo y ajustes estratégicos, alineando tus inversiones con el entorno financiero y tus objetivos de largo plazo.`,
        image: 'assets/svg/presenting.svg'
    }
];
